import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "../styles/Orders.css";
import { useNavigate } from "react-router-dom";

export default function Orders() {
  const { t } = useTranslation();
  const [orders, setOrders] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    loadOrders();
  }, []);

  const loadOrders = async () => {
    const response = await fetch("/api/orders", {
      credentials: "include",
    });

    if (response.ok) {
      setOrders(await response.json());
    }
  };

  return (
    <main className="orders-page">
      <section className="orders-container">
        <button
          className="profile-back-btn"
          onClick={() => navigate("/profile")}
        >
          ← {t("orders.backToProfile")}
        </button>
        <h1>{t("orders.title")}</h1>
        <p className="orders-subtitle">{t("orders.subtitle")}</p>

        {orders.length === 0 ? (
          <div className="orders-empty">
            <h2>{t("orders.emptyTitle")}</h2>
            <p>{t("orders.emptyText")}</p>

            <button onClick={() => navigate("/shop")}>
                {t("orders.goToShop")}
            </button>
          </div>
        ) : (
          <div className="orders-list">
            {orders.map((order) => (
              <article
                className="order-card"
                key={order.id}
                onClick={() => navigate(`/orders/${order.id}`)}
              >
                <div>
                  <h3>{order.orderNumber}</h3>
                  <p>{new Date(order.createdAt).toLocaleDateString()}</p>
                </div>

                <span>{t(`orders.status.${order.status}`)}</span>

                <strong>{Number(order.total).toFixed(2)} €</strong>
              </article>
            ))}
          </div>
        )}
      </section>
    </main>
  );
}